import axios from '../../axios/axios';

const EmployeeService = {
  getAllEmployees: () => {
    return axios.get("/employees");
  },

  getEmployeeById: (employeeId) => {
    return axios.get(`/employees/${employeeId}`)
  },

  addEmployee: (dateOfBirth, email, name, phoneNumber, surname, password, username) => {
    const newEmployee = {
      dateOfBirth,
      email,
      name,
      phoneNumber,
      surname,
      password,
      username
    }
    return axios.post("/employees/add", newEmployee, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  updateEmployee: (id, dateOfBirth, email, name, phoneNumber, surname, username) => {
    const updatedEmployee = {
      dateOfBirth,
      email,
      name,
      phoneNumber,
      surname,
      username
    }
    return axios.post(`/employees/update/${id}`, updatedEmployee, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  updateEmployeePassword: (id, oldPassword, newPassword) => {
    return axios.post(`/employees/update-password/${id}`, {
      oldPassword,
      newPassword
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
  },

  deleteEmployee: (id) => {
    return axios.delete(`employees/delete/${id}`)
  }
}

export default EmployeeService;